import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import ImportHolidaysModal from 'modules/locations/components/ImportHolidays'

const ImportHolidaysModalPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.holidays.fullPath({ id }))
  }

  return <ImportHolidaysModal locationId={id} onClose={onClose} />
}

export default ImportHolidaysModalPage
